import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";

export const ErrorBoundary = () => {
  const error = useRouteError();
  console.error(error);
  // A loader that throws a Response with a text body (for example "Order 123 not
  // found") gets that text shown; anything else keeps the generic line.
  const message =
    isRouteErrorResponse(error) && typeof error.data === "string" && error.data
      ? error.data
      : "Oops! Something went wrong.";
  return (
    <div className="h-[calc(100vh_-_64px)] w-full flex justify-center items-center flex-col">
      <h1 className="text-2xl">
        {message}
      </h1>
      <Link className="text-blue-500 underline" to="/login">
        Return Home
      </Link>
    </div>
  );
};
